import { render, staticRenderFns } from "./ChallengeVideoModal.vue?vue&type=template&id=7b79316d"
import script from "./ChallengeVideoModal.vue?vue&type=script&lang=js"
export * from "./ChallengeVideoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports